// src/pages/PricingPage.tsx — Site officiel Vanessa : tarifs de l'API
import { Link } from 'react-router-dom';
import { Handshake } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { PageHeader, Section, Steps, CtaBand, Container } from '@/components/site/blocks';

export default function PricingPage() {
    const { isAuthenticated } = useAuth();

    return (
        <>
            <PageHeader
                eyebrow="Tarifs"
                title="Pas d’abonnement forcé."
                intro="Vous proposez un montant pour un volume de tokens, nous validons ensemble."
            />
            <Section>
                <Container className="!px-0 max-w-3xl">
                    <div className="rounded-3xl border border-gray-200 bg-white p-8">
                        <Steps
                            items={[
                                { title: 'Faites votre proposition', text: 'Depuis votre console, indiquez le montant que vous proposez et le nombre de tokens souhaité.' },
                                { title: 'Nous vous recontactons', text: 'Sur WhatsApp ou par email, pour confirmer les modalités de paiement.' },
                                { title: 'Votre clé est activée', text: 'Une fois le paiement confirmé de notre côté, la clé est activée et affichée une seule fois.' },
                                { title: 'Rechargez quand vous voulez', text: 'Même avant épuisement : le nouveau quota s’additionne au restant.' },
                            ]}
                        />
                    </div>
                    <div className="mt-6 flex items-start gap-3 rounded-2xl bg-brand-tint p-5">
                        <Handshake className="mt-0.5 h-5 w-5 shrink-0 text-ochre" aria-hidden="true" />
                        <p className="text-base text-ink">
                            Média, association ou institution ? Certains volumes peuvent être offerts dans le cadre d’un partenariat.{' '}
                            <Link to="/entreprises" className="font-semibold text-ochre underline">Découvrir les partenariats</Link>
                        </p>
                    </div>
                </Container>
            </Section>
            <CtaBand
                title="Prêt à commencer ?"
                primary={{ label: 'Faire une demande', to: isAuthenticated ? '/console' : '/inscription' }}
                secondary={{ label: 'Lire la documentation', to: '/documentation', variant: 'secondary' }}
            />
        </>
    );
}
